'use client'
import React from 'react'
import { GoogleMap, Marker, OverlayView, LoadScript } from "@react-google-maps/api";
import { getMapLanguage, getMapRegion } from '@utils'

const Map = ({ latitude, longitude, maskLocation = false, lang = 'en' }) => {
    let mapLanguage = getMapLanguage(lang)
    let mapRegion = getMapRegion(lang)
    

    const approximateRadius = 200

    const containerStyle = {
        width: "100%",
        height: "600px",
    };

    const center = {
        lat: latitude,
        lng: longitude,
    };

    const customMarkerIcon = {
        url: "/images/marker.png",

    };

    const options = {
        disableDefaultUI: true,
        zoomControl: true,
    };

    const OverlayView2 = ({  }) => {
        return (
            <div
                style={{
                    position: 'absolute',
                    background: 'rgba(120, 177, 255, 0.3)', // Adjust the color and opacity as needed
                    borderRadius: '50%',
                    width: approximateRadius * 2,
                    height: approximateRadius * 2,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    pointerEvents: 'none',
                }}
            />
        )
    }

    return (
        <div className='mb-3 pb-3 pt-2 rounded-xl overflow-hidden'>
            <LoadScript 
                googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API}
                loading="async"
                language={mapLanguage}
                region={mapRegion}
            >
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={15} // Adjust the zoom level as needed
                    options={options}
                >
                    {maskLocation == false ? (
                        <Marker position={center} icon={customMarkerIcon} className=' filter-maincolor' scaledSize={20} />
                    ) : (
                        <OverlayView
                            position={center}
                            mapPaneName={OverlayView.OVERLAY_LAYER}
                            // mapPaneName={OverlayView.OVERLAY_LAYER}
                            getPixelPositionOffset={(width, height) => ({
                                x: -width / 2,
                                y: -height / 2,
                            })}
                        >
                            <OverlayView2 />
                        </OverlayView>
                    )}
                </GoogleMap>
            </LoadScript>
        </div>
    )
}

export default Map